export function constant (v0, v1, t) {
  t *= 100
  if (v0 > v1) {
    return Math.max(v0 - t, v1)
  }
  return Math.min(v0 + t, v1)
}

export function lerp (v0, v1, t) {
  return (1 - t) * v0 + t * v1
}

export function hexColor (v) {
  var str = ('000000' + v.toString(16)).slice(-6)
  // var rrggbb = bbggrr.substr(4, 2) + bbggrr.substr(2, 2) + bbggrr.substr(0, 2)
  var rrggbb = str.substr(0, 2) + str.substr(2, 2) + str.substr(4, 2)
  return '#' + rrggbb
}
